import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BreadcrumbService, Breadcrumb } from '../../../core/services/breadcrumb.service';
import { Observable } from 'rxjs';
import { HugeiconsIconComponent } from '@hugeicons/angular';
import { Home01Icon, ArrowRight01Icon } from '@hugeicons/core-free-icons';

@Component({
    selector: 'app-breadcrumb',
    standalone: true,
    imports: [CommonModule, RouterLink, HugeiconsIconComponent],
    templateUrl: './breadcrumb.component.html',
    styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent implements OnInit {
    breadcrumbs$: Observable<Breadcrumb[]>;
    
    // Icons
    homeIcon = Home01Icon;
    arrowRightIcon = ArrowRight01Icon;

    constructor(private breadcrumbService: BreadcrumbService) {
        this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;
    }

    ngOnInit(): void {
    }
}
